import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import FiltrosListaMestra from "model/documentos/FiltrosListaMestra";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";
import { defaultCompleteMethod, usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: (filtros: FiltrosListaMestra) => void;
}

const documentoPastaService = new DocumentoPastaService();
export default function ModalFiltrosListaMestra(props: Props) {
    const [filtros, setFiltros] = useState<FiltrosListaMestra>(new FiltrosListaMestra());

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);
    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);
    const [categoriasFiltradas, setCategoriasFiltradas] = useState<CategoriaDocumento[]>([]);
    const [pastas, setPastas] = useState<DocumentoPasta[]>([]);
    const [pastasFiltradas, setPastasFiltradas] = useState<DocumentoPasta[]>([]);

    useEffect(() => {
        documentoPastaService.categorias().then((response) => {
            setCategorias(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        })
        documentoPastaService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((error) => {
            console.error("Erro ao buscar usuarios:", error);
        })
        documentoPastaService.buscarTodas().then((response) => {
            setPastas(response);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
        })
    }, []);

    return (
        <Dialog header="Filtros" visible={props.visible} style={{ width: '50vw' }}
            onHide={() => {
                props.onHide();
            }}>
            <div className="row">
                <Label className="col col-sm-12">Interno/Externo</Label>
                <div className="col-sm-12">
                    <MultiSelect
                        value={filtros.internoExterno}
                        options={documentoPastaService.internoExterno()}
                        onChange={(e: MultiSelectChangeEvent) => {
                            setFiltros({ ...filtros, internoExterno: e.value })
                        }}
                        optionLabel="label"
                        optionValue="value"
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" >Categoria</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={filtros.categoria ?? null}
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: CategoriaDocumento) => item.nome}
                        suggestions={categoriasFiltradas}
                        completeMethod={(e) => {
                            let filtered: CategoriaDocumento[] = defaultCompleteMethod(categorias, e.query, "nome");
                            setCategoriasFiltradas(filtered);
                        }}
                        onChange={(e) => {
                            let filtrosListaMestraLocal = JSON.parse(JSON.stringify(filtros));

                            if (!e.target.value) {
                                filtrosListaMestraLocal.categoria = null;
                            } else if (typeof e.target.value == "string") {
                                let categoria = new CategoriaDocumento();
                                categoria.nome = e.target.value;
                                filtrosListaMestraLocal.categoria = categoria;
                            } else {
                                filtrosListaMestraLocal.categoria = e.target.value;
                            }

                            setFiltros(filtrosListaMestraLocal);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" >Responsavel</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={filtros.responsavel ?? null}
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                        suggestions={usuariosFiltrados}
                        completeMethod={(e) => {
                            let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                            setUsuariosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            let filtrosListaMestraLocal = JSON.parse(JSON.stringify(filtros));

                            if (!e.target.value) {
                                filtrosListaMestraLocal.responsavel = null;
                            } else if (typeof e.target.value == "string") {
                                let usuario = new Usuario();
                                usuario.nome = e.target.value;
                                filtrosListaMestraLocal.responsavel = usuario;
                            } else {
                                filtrosListaMestraLocal.responsavel = e.target.value;
                            }

                            setFiltros(filtrosListaMestraLocal);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Pasta</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={filtros.pasta ?? null}
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: DocumentoPasta) => item.nome}
                        suggestions={pastasFiltradas}
                        completeMethod={(e) => {
                            let filtered: DocumentoPasta[] = defaultCompleteMethod(pastas, e.query, "nome");
                            setPastasFiltradas(filtered);
                        }}
                        onChange={(e) => {
                            let filtrosListaMestraLocal = JSON.parse(JSON.stringify(filtros));

                            if (!e.target.value) {
                                filtrosListaMestraLocal.pasta = null;
                            } else if (typeof e.target.value == "string") {
                                let pasta = new DocumentoPasta(0, "");
                                pasta.nome = e.target.value;
                                filtrosListaMestraLocal.pasta = pasta;
                            } else {
                                filtrosListaMestraLocal.pasta = e.target.value;
                            }

                            setFiltros(filtrosListaMestraLocal);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <MultiSelect
                        value={filtros.status}
                        options={documentoPastaService.statuses()}
                        onChange={(e: MultiSelectChangeEvent) => {
                            setFiltros({ ...filtros, status: e.value })
                        }}
                        optionLabel="label"
                        optionValue="value"
                    />
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                <Button label="Confirmar"
                    onClick={() => {
                        let filtrosLocal = JSON.parse(JSON.stringify(filtros));
                        props.onConfirm(filtrosLocal)
                        props.onHide()
                    }} style={{ marginLeft: 8 }} />
            </div>

        </Dialog>
    );
}